module.exports = __webpack_public_path__ + "static/img-registration-b26bcc99cdb9150f719ff951e79d549c.png";